// we can add back email, phoneString, and phoneRegex later if needed from the old project's validate.js
export const phoneFormatter = /^((\+1)|1)? ?\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})( ?(ext\.? ?|x)(\d*))?$/;
